import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "antd";
import {
  changeModalMessage,
  changeTestSessionStatus,
  closeCommentModal,
} from "../store/slices/sessionSummarySlice";
import { ApplicationState } from "../store";
import TextArea from "antd/lib/input/TextArea";

interface SessionCommentModalProps {
  title: string;
  sessionId: string;
}

const SessionCommentModal: React.FC<SessionCommentModalProps> = ({
  title = "",
  sessionId = "",
}) => {
  const dispatch = useDispatch();

  const {
    commentModalMessage,
    commentModalVisible,
    commentModalPlaceholder,
  } = useSelector((state: ApplicationState) => state.sessionSummarySlice);

  const handleModalClose = useCallback(() => {
    dispatch(closeCommentModal());
  }, [dispatch]);

  const handleChangeMessage = useCallback(
    ({ target: { value } }) => {
      dispatch(changeModalMessage(value));
    },
    [dispatch]
  );

  const handleModalOk = useCallback(() => {
    dispatch(changeTestSessionStatus(sessionId));
  }, [dispatch, sessionId]);

  return (
    <Modal
      title={title}
      visible={commentModalVisible}
      width={700}
      zIndex={1040}
      onCancel={handleModalClose}
      onOk={handleModalOk}
      okButtonProps={{ disabled: !commentModalMessage }}
      maskClosable={false}
    >
      <TextArea
        value={commentModalMessage}
        onChange={handleChangeMessage}
        placeholder={commentModalPlaceholder}
        showCount
        maxLength={5000}
        autoSize={{ minRows: 3, maxRows: 7 }}
      />
    </Modal>
  );
};

export default SessionCommentModal;
